import type { Database } from "@/types/database.types";
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

function assertEnvPresent(value: string | undefined, name: string): string {
  if (!value || value.trim().length === 0) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
}

export const supabase: SupabaseClient<Database> = createClient<Database>(
  assertEnvPresent(supabaseUrl, "VITE_SUPABASE_URL"),
  assertEnvPresent(supabaseAnonKey, "VITE_SUPABASE_ANON_KEY"),
);